import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./custom.scss";
import store from "./store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import App from "./features/app/App";

import * as dotenv from "dotenv";
dotenv.config();




ReactDOM.render(
  <Provider store={store}>
    <App  />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
